import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import machineServiceImageDeleteAction from './machineServiceImageDelete.action.json' with { type: 'json' }

const machineServiceImageDeleteDefinition = defineAction({
  ...machineServiceImageDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default machineServiceImageDeleteDefinition
